<template>
  <v-app id="inspire" style="background: #f4f6f9" :lang="lang">
    <v-navigation-drawer
      v-if="!$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      color="#f5f5f5"
    >
      <v-list nav color="#f5f5f5">
        <v-list-item
          v-for="(item, i) in btnItems"
          :key="i"
          link
          @click="$vuetify.goTo(`#${item.id}`)"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>        
      </v-list>   
    </v-navigation-drawer>

    <v-app-bar
      fixed
      app
      elevate-on-scroll
      class="appbar"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
    >
      <v-container>
        <v-row align="center" justify="space-between">
          <v-col cols="12" md="5" class="d-flex align-center">
            <v-app-bar-nav-icon
              @click.stop="drawer = !drawer"
              v-if="!$vuetify.breakpoint.lgAndUp"
            />
            <v-toolbar-title
              style="cursor: pointer"
              class="font-weight-bold headline"
            >
              <v-icon large color="accent">
                mdi-airplane-takeoff
              </v-icon>
              Smart<span class="accent--text">NDC</span>
            </v-toolbar-title>
          </v-col>
          <v-col cols="12" md="5" class="text-right" v-if="$vuetify.breakpoint.lgAndUp">
            <v-btn
              text
              v-for="(item, i) in btnItems"
              :key="i"
              @click="$vuetify.goTo(`#${item.id}`)"
            >
              {{ item.name }}
            </v-btn>                      
          </v-col>
          <v-col cols="12" md="2">
            <v-select
            v-model="langSel"
            @change="selectLang"
            :items="langItems"
            item-text="title"
            item-value="id"
            text
            hide-details="auto"
            ></v-select>             
          </v-col>         
        </v-row>
      </v-container>
    </v-app-bar>

    <v-content>
      <v-sheet dark id="about">
        <v-img
          :src="require('@/assets/bg.jpg')"
          height="70vh"
          width="100vw"
        >
          <v-container class="fill-height">
            <v-row align="center" justify="center">
              <v-col class="text-left">
                <h3>
                  <p>
                    {{$t("lang.intro1")}}
                  </p>
                  <p>
                    {{$t("lang.intro2")}}
                  </p>
                </h3>
              </v-col>
            </v-row>
          </v-container>
        </v-img>
      </v-sheet>

      <v-container>
        <v-sheet color="transparent" id="services">
          <div class="pt-12 text-center">
            <h3 class="display-1 font-weight-blod">
              {{$t("lang.item2")}}
            </h3>
          </div>

          <v-row justify="center" align="center" class="mt-5">
            <v-col
              cols="12"
              md="3"
              v-for="(item, i) in services"
              :key="i"
              class="text-center"
            >
              <v-icon size="64" color="accent">
                {{ item.icon }}
              </v-icon>
              <h4 class="title my-2">
                {{ item.title }}
              </h4>
              <p>
                {{ item.subtitle }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-container>

      <v-sheet dark id="contact">
          <v-snackbar v-model="snackbar" timeout="4000" color="orange" top>
              {{ snackinfo }}
          </v-snackbar>
          <v-container class="fill-height">
            <v-row justify="center" align="center" class="mt-5">
              <v-col cols="12">
                <div class="pt-12 text-center">
                  <h3 class="display-1 font-weight-blod">
                    {{$t("lang.item3")}}
                  </h3>
                  <p class="body-2 my-3">
                    <span class="welcome">
                      
                    </span>
                  </p>
                </div>
              </v-col>

              <v-col cols="12" md="4" class="fill-height">
                <p><v-icon size="32">mdi-phone</v-icon>400-101-7518</p>
                <p><v-icon size="32">mdi-email</v-icon>smartndc@foxmail.com</p>
              </v-col>

              <v-col cols="12" md="8">
                <v-row justify="center" align="center" class="mt-5">
                  <v-col cols="12" md="4">
                    <v-text-field :label="$t('lang.c_name')" v-model="contact.name" hide-details="auto" solo light></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field :label="$t('lang.c_email')" v-model="contact.email" hide-details="auto" solo light></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field :label="$t('lang.c_phone')" v-model="contact.phone" hide-details="auto" solo light></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      light
                      solo
                      name="input-7-4"
                      :label="$t('lang.c_message')"
                      v-model="contact.msg" 
                      hide-details="auto"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <v-btn x-large color="accent" @click="checkForm">
                      {{$t("lang.c_send")}}
                    </v-btn>
                  </v-col>
                </v-row>                 
              </v-col>
            </v-row>
          </v-container>
      </v-sheet>
    </v-content>

    <v-footer>
      <v-container>
        <v-row align="center" justify="space-between">
          <v-col>
            <div>
              Copyright &copy; {{ new Date().getFullYear() }} {{$t("lang.copyright")}} All rights reserved
            </div>
          </v-col>

          <v-col class="text-right" v-if="$i18n.locale == 'cn'">
            <a text class="accent--text" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035640">
              京公网安备 11010802035640号
            </a>
            <a text class="pl-2 accent--text" href="https://beian.miit.gov.cn/">
              京ICP备14014971号-1
            </a>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    drawer: null,
    snackbar: false,
    snackinfo: "",
    contact: {},
    btnItems: [],
    services: [],
    langItems: [
        {title: "简体中文", id: "cn"},
        {title: "繁體中文", id: "hk"},
        {title: "日本語", id: "jp"},
        {title: "한국어", id: "kr"},
        {title: "English", id: "en"},
      ],
  }),
  mounted () {
    this.langSel = this.$i18n.locale,
    this.btnItems = [{id:"about", name:this.$t('lang.item1')}, {id:"services", name:this.$t('lang.item2')}, {id:"contact", name:this.$t('lang.item3')}]
    this.services = [
      {
        icon: "mdi-store",
        title: this.$t('lang.title1'),
        subtitle: this.$t('lang.subtitle1'),
      },
      {
        icon: "mdi-cellphone",
        title: this.$t('lang.title2'),
        subtitle: this.$t('lang.subtitle2'),
      },
      {
        icon: "mdi-api",
        title: this.$t('lang.title3'),
        subtitle: this.$t('lang.subtitle3'),
      },
      {
        icon: "mdi-code-json",
        title: this.$t('lang.title4'),
        subtitle: this.$t('lang.subtitle4'),
      },
      {
        icon: "mdi-cloud",
        title: this.$t('lang.title5'),
        subtitle: this.$t('lang.subtitle5'),
      },
      {
        icon: "mdi-server-security",
        title: this.$t('lang.title6'),
        subtitle: this.$t('lang.subtitle6'),
      },
      {
        icon: "mdi-update",
        title: this.$t('lang.title7'),
        subtitle: this.$t('lang.subtitle7'),
      },
      {
        icon: "mdi-phone-in-talk",
        title: this.$t('lang.title8'),
        subtitle: this.$t('lang.subtitle8'),
      },      
    ]
  },
  methods: {
    checkForm: function () {
      this.errors = [];

      if (!this.contact.name) {
        this.errors.push("Name required.");
      }
      if (!this.contact.email) {
        this.errors.push('Email required.');
      } else if (!this.validEmail(this.contact.email)) {
        this.errors.push('Valid email required.');
      }
      if (!this.contact.phone) {
        this.errors.push("Phone required.");
      }
      if (!this.contact.msg) {
        this.errors.push("Message required.");
      }

      if (this.errors.length > 0) {
        this.snackinfo = this.errors[0];
        this.snackbar = true;
        return false;
      } else {
        this.contact.product = "SmartNDC";
        this.$axios({
                 url: '	http://1.117.179.53:8822/front/contact/addContactInfo',
                 method:'post',
                 data:this.contact,
               });
        this.snackinfo = "send message success.";
        this.snackbar = true;
        return true;
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    selectLang: function () {
      let url = location.href;
      let beg = url.indexOf("//");
      let end = url.indexOf("/", beg+2);
      if(end == -1) {
        url += "/";
      } else {
        url = url.substring(0, end+1);
      }
      location.href = url + this.langSel;
    }
  }
};
</script>

<style lang="scss">
.display-2,
.body-2 {
  .welcome {
    font-family: "Droid Serif", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
    font-style: italic;
  }
}
</style>
